// src/components/Studio/StudioShell.tsx
import type { ReactNode } from 'react';
import MainLayout from '../MainLayout/MainLayout';
import { SURFACE } from './studioStyles';

/**
 * Page wrapper for every Studios & Community surface.
 *
 * Also supplies the `<main>` landmark the rest of the app is missing, so keyboard and
 * screen-reader users get a skip target on these pages.
 */
const StudioShell = ({ children }: { children: ReactNode }) => (
  <MainLayout>
    <main id="main-content" className={`min-h-screen ${SURFACE}`}>
      {children}
    </main>
  </MainLayout>
);

export default StudioShell;
